export default {

    /**
     * Collapse a nested arrays into one array.  
     * Ex, `[0,[1,2],[3,[4]]]` ==> `[0,1,2,3,4]`
     * 
     * @param {...any} arr Array to flatten
     * @param {Function} fn Array to flatten
     */
    flatten: function (arr, fn) {
        return arr.reduce(
            (acc, val) => acc.concat(
                Array.isArray(val) ? this.flatten(val) : fn === undefined ? val : fn(val)
            ), []);
    },

    slice: function (array, start, end) {
        // 
        array = Array.from(array);
        end = end || array.length;
        // 
        return array.slice(start, end);
    }
}